export const schemas_ko = {
  email: {
    required: '이메일 주소를 입력하세요.',
    invalid: '유효하지 않은 이메일입니다.',
  },
  password: {
    required: '비밀번호를 입력하세요.',
    validation: '비밀번호는 문자, 숫자, 특수기호 중 3개를 포함한 8자 이상이여야 합니다.',
  },
  captchaToken: {
    required: '캡챠는 필수입니다.',
  },
  code: {
    required: '인증 코드는 필수입니다.',
  },
};
